export const MenuHeading = [
  {
    id: 1,
    Name: "Home",
    link: "/",
  },
  {
    id: 2,
    Name: "IIChE",
    link: "/aboutiiche",
  },
  {
    id: 3,
    Name: "Student Chapter",
  },
  {
    id: 4,
    Name: "Department",
  },
];

export const MenuHeading1 = [
  {
    id: 1,
    Name: "Events",
  },
];

export const MenuHeading2 = [
  {
    id: 1,
    Name: "Contact Us",
  },
];

export const DropdownLinks = [
  {
    id: 1,
    Name: "Alumni and Industry Connect",
    link: "aluminiandindustryconnect",
  },
  {
    id: 2,
    Name: "Editorial",
    link: "editorial",
  },
  {
    id: 3,
    Name: "Graphics and Design",
    link: "graphicsandDesign",
  },
  {
    id: 4,
    Name: "Program",
    link: "/program",
  },
  {
    id: 5,
    Name: "Publicity",
    link: "publicity",
  },
  {
    id: 6,
    Name: "Public Relations",
    link: "publicrelations",
  },
  {
    id: 7,
    Name: "Social and Environmental ",
    link: "socialandenvironmental",
  },
  {
    id: 8,
    Name: "Technical",
    link: "/technical",
  },
 
  
 
  
  
];

export const DropdownLinks2 = [
  {
    id: 1,
    Name: "2024 - 2025",
    link: "/ec2025",
  },
  {
    id: 2,
    Name: "2023 - 2024",
    link: "/ec2024",
  },
  {
    id: 3,
    Name: "2022 - 2023",
    link: "/ec2023  ",
  },
];

export const FacultyData = [
  {
    id: 5,
    cover: "../images/Dr_Sasangan_Ramanathan.jpg",
    Name: "Dr. Sasangan Ramanathan",
    description:
      " Professor, Department of Chemical Engineering and Materials  Science, School Of Engineering, Coimbatore",
    email: "deanengg@amrita.edu",
  },
  {
    id: 1,
    cover: "../images/nikhil.jpg",
    Name: "Dr. Nikhil K. Kothurkar",
    description:
      " Chairperson Professor, Department of Chemical Engineering and Materials Science, School of Engineering, Coimbatore",
    email: "k_nikhil@cb.amrita.edu",
  },
  {
    id: 2,
    cover: "../images/R. Krishna Prasad.jpg",
    Name: "Dr. Krishna Prasad R.",
    description:
      "Vice Chairperson Assistant Professor (SG), Department of Chemical Engineering and Materials Science, School of Engineering, Coimbatore",
    email: "r_krishnaprasad@cb.amrita.edu",
  },
  {
    id: 3,
    cover: "../images/Jayanarayan.jpg",
    Name: "Dr. Jayanarayanan K.",
    description:
      " Professor, Department of Chemical Engineering and Materials  Science, School Of Engineering, Coimbatore",
    email: "kj_narayanan@cb.amrita.edu",
  },
  {
    id: 4,
    cover: "../images/Dr-Meera-Balachandran.jpg",
    Name: "Dr. Meera Balachandran",
    description:
      " Professor, Department of Chemical Engineering and Materials  Science, School Of Engineering, Coimbatore",
    email: "b_meera@cb.amrita.edu",
  },
  {
    id: 7,
    cover: "../images/Dr.-Murali-Rangarajan.jpg",
    Name: "Dr. Murali Rangarajan",
    description:
      "Professor, Center of Excellence in Advanced Materials & Green Technologies, Coimbatore",
    email: "r_murali@cb.amrita.edu",
  },
  {
    id: 8,
    cover: "../images/Dr.-Duraisamy-Kumaresan.jpg",
    Name: "Dr. Duraisamy Kumaresan",
    description:
      " Professor, Department of Chemical Engineering and Materials  Science, School Of Engineering, Coimbatore",
    email: "k_duraisamy@cb.amrita.edu",
  },
  {
    id: 10,
    cover: "../images/Dr-Uday.jpeg",
    Name: "Dr. Udaya Bhaskar Reddy Ragula",
    description:
      " Professor, Department of Chemical Engineering and Material Sciences, Coimbatore",
    email: "u_bhaskarreddy@cb.amrita.edu",
  },
  {
    id: 11,
    cover: "../images/thirugnasambandam-g-manivasagam.jpg",
    Name: "Dr. Thirugnasambandam G. Manivasagam",
    description:
      "Associate Professor (SG), Department of Chemical Engineering and Materials Science, Coimbatore",
    email: "gm_thiru@cb.amrita.edu",
  },
  {
    id: 12,
    cover: "../images/nithya-k.png",
    Name: "Dr. Nithya K.",
    description:
      "Assistant Professor (SG), Chemical Engineering and Materials Science, School of Engineering, Coimbatore",
    email: "k_nithya@cb.amrita.edu",
  },

  {
    id: 13,
    cover: "../images/Dr-Rasana.jpeg",
    Name: "Dr. Rasana Nanoth",
    description:
      "Assistant Professor (SG), Chemical Engineering and Materials Science, School of Engineering, Coimbatore",
    email: "n_rasana@cb.amrita.edu",
  },
  {
    id: 14,
    cover: "../images/kannan.png",
    Name: "Dr. Kannan M.",
    description:
      "Assistant Professor (SG), Chemical Engineering and Materials Science, School of Engineering, Coimbatore",
    email: "m_kannan@cb.amrita.edu",
  },

  {
    id: 16,
    cover: "../images/Sindhu-S.jpg",
    Name: "Dr. S. Sindhu",
    description:
      "Assistant Professor (SG), Chemical Engineering and Materials Science, School of Engineering, Coimbatore",
    email: "s_sindhu@cb.amrita.edu",
  },
  {
    id: 15,
    cover: "../images/Hareesh.jpg",
    Name: "Hareesh Padayath",
    description:
      "Assistant Professor (SG), Chemical Engineering and Materials Science, School of Engineering, Coimbatore",
    email: "p_hareesh@cb.amrita.edu",
  },

  {
    id: 18,
    cover: "../images/Amal_GS.jpg",
    Name: "Amal G. S.",
    description:
      "Assistant Professor (SG), Department of Chemical Engineering & Materials Science, Amrita Vishwa Vidyapeetham, Coimbatore.",
    email: "gs_amal@cb.amrita.edu",
  },
];

export const SliderData = [
  {
    image: "../images/college.jpg",
  },
  {
    image: "../images/Group Pic.JPG",
  },
  {
    image: "../images/IIche Ec.JPG",
  },
  {
    image: "../images/inagural.JPG",
  },
  {
    image: "../images/inagural12.JPG",
  },
  {
    image: "../images/inagural1.JPG",
  },
  {
    image: "../images/inagural2.JPG",
  },
  {
    image: "../images/inagural11.JPG",
  },
  {
    image: "../images/inagural3.JPG",
  },
  {
    image: "../images/inagural4.JPG",
  },
  {
    image: "../images/inagural7.JPG",
  },
  {
    image: "../images/inagural10.JPG",
  },
  {
    image: "../images/inagural5.JPG",
  },
  {
    image: "../images/inagural6.JPG",
  },

  {
    image: "../images/inagural8.JPG",
  },
  {
    image: "../images/inagural9.jpeg",
  },
];

export const Departments = [
  {
    id: 1,
    cover: "../images/public_relations.jpg",
    Name: "Public Relations",
  },
  {
    id: 2,
    cover: "../images/publicity.jpg",
    Name: "Publicity",
  },
  {
    id: 3,
    cover: "../images/Program.jpg",
    Name: "Program",
  },
  {
    id: 4,
    cover: "../images/Technical.jpg",
    Name: "Technical",
  },
  {
    id: 5,
    cover: "../images/Editorial.jpg",
    Name: "Editorial",
  },
  {
    id: 6,
    cover: "../images/alumini.jpg",
    Name: "Alumini Industry Connect",
  },
  {
    id: 7,
    cover: "../images/Graphics.jpg",
    Name: "Graphics and Design",
  },
  {
    id: 8,
    cover: "../images/social.jpg",
    Name: "Social and Environmental",
  },
];

export const ProgramCommitte = [
  {
    id: 1,
    Name: "Program ",
    heading: "Get to know our team",
    profilephoto1: "../images/Poojitha.jpg",
    profilename1: "Ambati Poojitha",
    post1: "Head",
    profilephoto2: "../images/Niranjan.jpg",
    profilename2: "Niranjana Anur Aruna",
    post2: "Head",
    profilephoto3: "../images/Haritha.jpg",
    profilename3: "R Haritha",
    post3: "Co-Head",
    profilephoto4: "../images/Tracy_Cordelia.jpg",
    profilename4: "C Tracy Cordelia",
    post4: "Co-Head",
  },
];

export const SocialEnvironmnetalCommitte = [
  {
    id: 1,
    Name: "SOCIAL AND ENVIRONMENTAL",
    heading: "Get to know our team",
    profilephoto1: "../images/Aadithya.jpg",
    profilename1: "Aadithya R Nair",
    post1: "Head",
    profilephoto2: "../images/AdityaDev.jpg",
    profilename2: "Adithya Dev A",
    post2: "Head",
    profilephoto3: "../images/Namrithasre.jpg",
    profilename3: " M Namrithasre",
    post3: "Co-Head",
    profilephoto4: "../images/Santhosh.jpg",
    profilename4: "  Santhosh A",
    post4: "Co-Head",
  },
];

export const TechnicalCommitte = [
  {
    id: 1,
    Name: "Technical ",
    heading: "Get to know our team",
    profilephoto1: "../images/Dhivyan.jpg",
    profilename1: "Dhivyan PB",
    post1: "Head",
    profilephoto2: "../images/photo.png",
    profilename2: "Deepthisri KR",
    post2: "Head",
    profilephoto3: "../images/Mahima.jpg",
    profilename3: "Mahima S",
    post3: "Co-Head",
    profilephoto4: "../images/Dharshan.jpg",
    profilename4: "Dharshan B",
    post4: "Co-Head",
  },
];

export const EditorialCommitte = [
  {
    id: 1,
    Name: "Editorial ",
    heading: "Get to know our team",
    profilephoto1: "../images/Harni.jpg",
    profilename1: "Harini C",
    post1: "Head",
    profilephoto2: "../images/Swarnakamatchi .jpg",
    profilename2: "Swarnakamatchi R",
    post2: "Head",
    profilephoto3: "../images/Aparna .jpg",
    profilename3: "Aparna Shankar",
    post3: "Co-Head",
    profilephoto4: "../images/Rithan.jpg",
    profilename4: "Rithan K A",
    post4: "Co-Head",
  },
];

export const GraphicsandDesignCommitte = [
  {
    id: 1,
    Name: "Graphics and Design ",
    heading: "Get to know our team",
    profilephoto1: "../images/Abijith.JPG",
    profilename1: "Abhijith Babu",
    post1: "Head",
    profilephoto2: "../images/photo.png",
    profilename2: "Paruchuri Ananyasai",
    post2: "Head",
    profilephoto3: "../images/Krishnaendu.jpg",
    profilename3: " S Krishnaendu Nair",
    post3: "Co-Head",
    profilephoto4: "../images/Visram.jpg",
    profilename4: "Visram Anand R V",
    post4: "Co-Head",
  },
];

export const AlumniandIndustryConnectCommitte = [
  {
    id: 1,
    Name: "Alumni and Industry Connect",
    heading: "Get to know our team",
    profilephoto1: "../images/Anukruthika.jpg",
    profilename1: "Anukrithika R",
    post1: "Head",
    profilephoto2: "../images/Rahul.jpg",
    profilename2: "Rahul Kishor",
    post2: "Head",
    profilephoto3: "../images/Gobika.jpg",
    profilename3: "K Gobika",
    post3: "Co-Head",
    profilephoto4: "../images/Krdvi.jpg",
    profilename4: "PG Krdvi Sree",
    post4: "Co-Head",
  },
];

export const PublicRelationsCommitte = [
  {
    id: 1,
    Name: "Public Relations ",
    heading: "Get to know our team",
    profilephoto1: "../images/Abaya.jpg",
    profilename1: "Abaya Pradahan",
    post1: "Head",
    profilephoto2: "../images/Nistha.jpg",
    profilename2: "Nishtha Sinha",
    post2: "Head",
    profilephoto3: "../images/Nishiga.jpg",
    profilename3: "M Nishiga",
    post3: "Co-Head",
    profilephoto4: "../images/Poobithasri.jpg",
    profilename4: "Poobithasri V S",
    post4: "Co-Head",
  },
];

export const PublicityCommitte = [
  {
    id: 1,
    Name: "Publicity ",
    heading: "Get to know our team",
    profilephoto1: "../images/Arathi.jpg",
    profilename1: "Arathi Sreekumar",
    post1: "Head",
    profilephoto2: "../images/Deetcha.jpg",
    profilename2: "Deetchana Manivel",
    post2: "Head",
    profilephoto3: "../images/Anjali.jpg",
    profilename3: "Anjali A S",
    post3: "Co-Head",
    profilephoto4: "../images/Bhavithira.jpg",
    profilename4: "Bhavithira M",
    post4: "Co-Head",
  },
];

export const EventsData = [
  {
    id: 1,
    image: "../images/ChemTalk1.jpg",
    Heading: "CHEM TALK-1",
    paragraph:
      "🎙️ ChemTalk 2023: Our Student Chapter hosted an inaugural technical talk featuring experts from Schlumberger. Insights on Gas Processing, Seawater Extraction, and Real-Life Design Practices were shared. An enriching session with industry leaders. 🌐 #ChemTalk2023 #IndustryExperts",
  },
  {
    id: 2,
    image: "../images/EventPoster.jpeg",
    Heading: "CHEM TALK-2",
    paragraph:
      "🌍✨ Alumni Talk Series: Dr. Mukund Rao 🎙️ A 2012 graduate, he shared insights on climate science, its historical context, and future projections. The event, in collaboration with Student Energy, delved into the scientific basis of climate change, addressing crucial questions. A thought-provoking session advancing our understanding of the past, present, and future of our climate. 📆 #AlumniTalk #ClimateScience #StudentEnergy",
  },
  {
    id: 3,
    image: "../images/ChemTalk3.jpg",
    Heading: "CHEM TALK-3",
    paragraph:
      "🌟 Honored Guest Lecture: Mr. Chiranjeevulu S 🎓 Retired Chief Manager from Mangalore Refinery and Petrochemicals Ltd. With over 24 years in Quality Control, he shared profound insights into petroleum refining and research aspects. Despite the online setting, Mr. Chiranjeevulu's wisdom illuminated new frontiers in Chemical Engineering. 📆 #GuestLecture #ChemicalEngineering #MRPL",
  },
  {
    id: 4,
    image: "../images/ChemTalk4.jpg",
    Heading: "CHEM TALK-4",
    paragraph:
      "🎙️ Chem Talk 4 Highlights: Featuring Mr. Vignesh Sankar, Distinguished Technologist at Reliance Industries Limited, as Chief Guest. An insightful session on 'An Insight into the Petrochemical Industry,' covering derivatives, job roles, simulation tools, and the future landscape. Valuable advice on industry connections, meaningful projects, and understanding engineer expectations. 🌐 #ChemTalk4 #PetrochemicalIndustry #EngineeringInsights",
  },
  {
    id: 5,
    image: "../images/TRIVIA TITANS.jpeg",
    Heading: "TRIVIA TITAN",
    paragraph:
      "🌐 IIChE AVVU Student Chapter Presents: Trivia Titan 🧠✨ An online quiz in honor of National Thermal Engineer Day and World Nature Conservation Day. 30 questions, 15 mins, open to all B.Tech departments and years. Engage, Learn, Conserve! 📆 #TriviaTitan #IIChEAVVU #EngineeringQuiz",
  },
  {
    id: 6,
    image: "../images/OceanOdyssey.jpg",
    Heading: "OCEAN ODYSSEY",
    paragraph:
      "🌊 Ocean Day Commemoration Event 📅✨ Join us in celebrating Ocean Day on June 8, 2023! Engage in our poster creation and essay writing competitions open to all B.Tech departments. Express your creativity, passion for the ocean, and contribute to marine conservation awareness. 🖊️🎨 #OceanDayEvent #StudentChapter #MarineConservation",
  },
  {
    id: 7,
    image: "../images/ConnectEd.jpg",
    Heading: "CONNECT-ED-CAREERS",
    paragraph:
      "🌐 Connect-ed-Careers Event 🤝 Special thanks to Dr. Shrisudersan Jayaraman, Senior Research Associate at Corning Incorporated, USA, our esteemed chief guest! An interactive session bridging academia and industry, offering invaluable insights to Chemical Engineering students. Elevate your understanding of industry dynamics, stay updated, and identify essential skillsets for successful placements. 🎓🌟 #ConnectEdCareers #ChemicalEngineering #IndustryInsights",
  },
  {
    id: 8,
    image: "../images/bpcl.png",
    Heading: "INDUSTRIAL VISIT",
    paragraph:
      "🏭 Industry Visit: BPCL Kochi 🌐✨ Gain insights into the world of Bharat Petroleum Corporation Limited! Mr. Pranav, an engineer, provided a seminar on industry basics, refinery processes, and products. Explore practical applications, refine your understanding of PFDs, safety, and environmental considerations. Bridge classroom knowledge with real-world practices. 🛢️🌿 #BPCLVisit #IndustryInsights #ChemicalEngineering",
  },
  {
    id: 9,
    image: "../images/IIcheInagural.jpg",
    Heading: "IIChE INAUGURATION",
    paragraph:
      "🎓 IIChE Student Chapter Inauguration 🌐✨ A milestone in the journey of chemical engineering students at Amrita Vishwa Vidyapeetham! Chief guests: Dr. T Kannadasan and Dr. Sasanga Ramanathan. IIChE, a national professional body, offers a platform for networking, knowledge exchange, and professional development. Join us in promoting research, innovation, and industry-academia collaboration. 🤝🔬 #IIChEInauguration #ChemicalEngineering #ProfessionalDevelopment",
  },
  {
    id: 10,
    image: "../images/Solarphoto.jpg",
    Heading: "WORKSHOP ON SOLAR PHOTOVOLTAIC APPLICATIONS",
    paragraph:
      "☀️ Solar PV Workshop: Inaugural Event 🌐✨ A three-day journey into Solar Photovoltaics Applications! Esteemed speakers - Dr. Kalyanasundaram, Dr. Krishnamoorthy, Professor Uchida, Dr. Sudip Kumar, and Dr. Duraisamy Kumaresan. Explore fabrication, organic photovoltaics, Dye-Sensitized, and perovskite solar cells. Dive into CIGS solar cells and electrochemical impedance analysis. Conclude with a hands-on DIY session on harnessing solar energy. 🌞🔧 #SolarPVWorkshop #RenewableEnergy #EngineeringInsights",
  },
  {
    id: 11,
    image: "../images/DesignofDistillationColoumn.jpg",
    Heading: "WORKSHOP ON DESIGN OF DISTILLATION COLUMN USING MICROSOFT EXCEL",
    paragraph:
      "📊 Distillation Column Design Workshop 🌐✨ Kudos to Dr. Udhay Bhaskar Reddy Ragula! Dive into hands-on Excel-based learning. Master equilibrium data estimation, feed quality calculations, and crucial distillation column parameters. Elevate your skills in vapor pressure, relative volatility, and tray estimation. 📈🔧 #DistillationDesign #EngineeringWorkshop #ExcelLearning",
  },

  {
    id: 12,
    image: "../images/Kickoff'23.jpg",
    Heading: "KICK-OFF'23",
    paragraph:
      "Kick-Off'23: A Resounding Victory Celebration! Elevating Campus Energy with Thrilling Football, Fundraising, and Unforgettable Moments. ⚽🏆 #KickOff23 #CampusTriumph #SportsAndSpirit",
  },
  {
    id: 13,
    image: "../images/Onspotphotography.png",
    Heading: "SPOT PHOTOGRAPHY",
    paragraph:
      "Join the On-Spot Photography Competition hosted by IIChE SC! Unleash your artistic vision and encapsulate the essence of the moment. Are you ready to leave your imprint? Let your snapshots narrate tales and evoke sentiments! 📸✨ #LensOfLife #CaptureTheMoment #IIChEPhotography",
  },
  {
    id: 14,
    image: "../images/Kickoff'24.png",
    Heading: "KICK OFF’24",
    paragraph:
      "Kick-Off '24: Where Passion Meets the Pitch!Uniting the campus with thrilling football, impactful fundraising, and unforgettable camaraderie. ⚽🏆 #KickOff24 #GameOn #CampusSpirit",
  },
  {
    id: 15,
    image: "../images/chemESeries.png",
    Heading: "ChemE Silver Series-1",
    paragraph:
      "The inaugural ChemE Silver Series seminar by IIChE-AVVU featured Dr. Ramakrishnan Shanmugam from Newcastle University, UK, who discussed green hydrogen production, electrolyzer challenges, and sustainable technologies. The session provided insights into renewable energy, electrolyzer applications, and their advantages and limitations. Faculty support and active participation from students, including a productive Q&A session, made the event a success, broadening perspectives on sustainable energy research.",
  },
  {
    id: 16,
    image: "../images/ICOPES.JPG",
    Heading:
      "ADVANCEMENTS AND APPLICATIONS OF ICP-OES TECHNOLOGY BY AGILENT TECHNOLOGIES",
    paragraph:
      "Empowering Education with Agilent Technologies! #AgilentTechnologies #ICP_OES #CoEAMGT #InnovationInEducation",
  },
  {
    id: 17,
    image: "../images/TechnicalDungeon.jpg",
    Heading: "Technical Dungeon",
    paragraph:
      "Technical Dungeon: A Test of Knowledge and Teamwork! #TechnicalDungeon #Teamwork #ScienceChallenge #ProblemSolving",
  },
  {
    id: 18,
    image: "../images/semiconductor.jpg",
    Heading: "Chemical Engineering in Semiconductors",
    paragraph:
      "Exploring Chemical Engineering in Semiconductors!  #ChemicalEngineering #Semiconductors #CareerDevelopment #Innovation",
  },
  {
    id: 19,
    image: "../images/PathQuest.jpg",
    Heading: "Path Quest ",
    paragraph:
      "Path Quest: A Test of Ingenuity and Teamwork!  #PathQuest #ProblemSolving #Teamwork #Innovation",
  },
  {
    id: 20,
    image: "../images/Techfair.jpg",
    Heading: "Tech-Fair",
    paragraph:
      "Anokha 2024: Showcasing Innovation for a Sustainable Future! #Anokha2024 #SustainableDevelopment #Innovation #Techfair #StudentProjects",
  },
  {
    id: 21,
    image: "../images/campaign.jpg",
    Heading: "IIChE Campaign",
    paragraph:
      "Anokha 2024: Engaging the Community with IIChE! #Anokha2024 #IIChE #PublicityCampaign #CommunityEngagement #StudentLife",
  },
  {
    id: 22,
    image: "../images/inductionandfeciliation.jpg",
    Heading: "INDUCTION & FAREWELL EVENT",
    paragraph:
      "Celebrating Leadership and Innovation: IIChE Induction and Felicitation Ceremony!#IIChE #InductionCeremony #Leadership #Celebration #FutureOfInnovation",
  },
  {
    id: 23,
    image: "../images/session.jpg",
    Heading: "L&T SESSION",
    paragraph:
      "Empowering Future Engineers: Industrial Piping Engineering Tutorials!#IndustrialPiping #EngineeringEducation #IIChE #FutureEngineers #PipingTechnology",
  },
];

export const EventReadmoreData = [
  {
    id: 1,
    EventTitle: "CHEM TALK-1",
    Date: "15.06.2023",
    EventDescription:
      "The inaugural ChemTalk event organized by our student chapter  featured distinguished chemical engineers from Schlumberger: Mr. Manivannan Natarajan, Mr. Shivakumar B, Mrs. Nishevitha, and Mr. Madaneshwar. The guests shared their career experiences and their views on various topics, including gas processing processes, extraction of crude oil from seawater and how design is practiced real-time in industries. Mr. Manivannan, with 22 years of experience in process design, engineering, and operations, provided insights into his career and the industry. Mr. Shivakumar B shared experiences in tendering and project execution of seawater treatment services. Mrs. Nishevitha discussed typical gas processing environments, while Mr. Madaneshwar, an esteemed alumnus, shared his professional journey and provided valuable tips for skill enhancement.",
  },
  {
    id: 2,
    EventTitle: "CHEM TALK-2",
    Date: "17.08.2023",
    EventDescription:
      "We had the honor of hosting one of our esteemed alumni, Dr. Mukund Rao, a graduated student from the class of 2012. Dr. Rao, an accomplished Ecologist and Carbon Cycle Scientist, shared his enriched experience in the field during an insightful event organized in collaboration with Student Energy. Notably, Dr. Mukund expanded the scope of his discussion to include his research on determining the age of trees and exploring the average global temperature. This added dimension provided a more holistic understanding of the environmental challenges we face. He expounded on historical shifts in climate, shedding light on the causes and consequences of climate change. His informative session also addressed the question of responsibility in tackling climate issues. In summary, Dr. Mukund Rao's presentation was a valuable contribution to our collective understanding of climate science. His expertise as an Ecologist and Carbon Cycle Scientist, combined with his insights into the past, present, and future aspects of climate change, made the event both educational and enlightening.",
  },
  {
    id: 3,
    EventTitle: "CHEM TALK-3",
    Date: "31.08.2023",
    EventDescription:
      "We were honored to host Mr. Chiranjeevulu S, who recently concluded his tenure as Chief Manager at Mangalore Refinery and Petrochemicals Ltd. With a distinguished career spanning over 24 years at MRPL Mangalore, Mr. Chiranjeevulu served as a key resource in multiple capacities within the Quality Control Team. Throughout the session, Mr. Chiranjeevulu provided an extensive discourse on petroleum refineries, focusing particularly on research aspects within the field. His comprehensive elucidation covered various facets of petroleum refining. Despite the virtual nature of the session, he effectively conveyed his expertise, guiding us towards new horizons in the realm of Chemical Engineering",
  },
  {
    id: 4,
    EventTitle: "CHEM TALK-4",
    Date: "23.09.2023",
    EventDescription:
      "Chem Talk 4 featured Mr. Vignesh Sankar, a distinguished technologist at Reliance Industries Limited, as the esteemed chief guest. Mr. Sankar delivered an enriching speech titled An Insight into the Petrochemical Industry, offering invaluable knowledge to the audience. He delved into petrochemicals and their derivatives, emphasizing job roles for chemical engineers, simulation tools commonly utilized in the field, and the future of petrochemical industries. Addressing the future of petrochemicals and their integration levels with refineries, he advised the audience to cultivate connections with industry professionals and seniors to understand industry workings and engineer expectations, emphasizing the importance of focusing on meaningful projects",
  },
  {
    id: 5,
    EventTitle: "TRIVIA TITAN",
    Date: "05.08.2023",
    EventDescription:
      "The student chapter of IIChE AVVU hosted an online event called Trivia Titan in observance of National Thermal Engineer Day and World Nature Conservation Day. It was a timed quiz consisting of 30 questions with a time limit of 15 minutes. This event included the participation of all the B.Tech. departments and all the years. This contest provided participants with a platform to express their knowledge, accuracy, time management, and critical thinking skills. The winner was Nelson Paul A. (CB.EN.U4CHE21030) with a score of 37115 and 90% accuracy. He was awarded a certificate and a winning amount of Rs. 500.",
  },
  {
    id: 6,
    EventTitle: "OCEAN ODYSSEY",
    Date: "19.06.2023",
    EventDescription:
      "The event was planned to commemorate Ocean Day, which falls on June 8, 2023. This event featured two competitions: one for creating posters online and the other for writing essays. The event included participation from all B.Tech. departments. Students were allotted an hour for essay writing and a week for submitting their posters on MS Forms. This event aimed to raise awareness about our student chapter and engage the student community in various activities to express their creativity, passion for the ocean, and knowledge about marine conservation.",
  },
  {
    id: 7,
    EventTitle: "CONNECT-ED-CAREERS",
    Date: "07.09.2023",
    EventDescription:
      "Our special thanks go to Dr. Shrisudersan Jayaraman, the Senior Research Associate at Corning Incorporated, USA, who graciously accepted our invitation to be the chief guest for the event. Connect-ed-Careers was an interactive session that brought together Dr. Shrisudersan Jayaraman, students as well as our dedicated faculties. The event primarily aimed to bridge the gap between academia and industry, offering students invaluable insights into the world of chemical engineering. Attended by enthusiastic 2nd, 3rd, and 4th-year Chemical Engineering students, Connect-ed-Careers served as a platform for understanding industry dynamics, staying updated with current developments, and identifying essential skills required for successful placements.",
  },
  {
    id: 8,
    EventTitle: "INDUSTRIAL VISIT",
    Date: "27.05.2023",
    EventDescription:
      "The visit mainly focused on giving students a general view and experience of industries and helping them relate their curriculum. Mr. Pranav, who is an engineer, gave us a brief seminar on the basics of the industry and the processes and products of the refinery. After a small break, we were taken on a small tour around the refinery to show the basic infrastructure and processes. We got insights on practical applications of PFDs, knowledge of refining processes, awareness of safety and environmental considerations, and understanding the technicalities of industrial operations. We also had an overview of environmental and sustainability awareness, the integration of classroom knowledge, and industry practices.",
  },
  {
    id: 9,
    EventTitle: "IICHE INAUGURATION",
    Date: "20.10.2023",
    EventDescription:
      "The IIChE Student Chapter Inauguration at Amrita Vishwa Vidyapeetham was a momentous occasion, marked by a series of distinguished events. We were fortunate to have Dr. T. Kannadasan and Dr. Sasangan Ramanathan as our chief guests.Dr. Sasangan Ramanathan, our dean, shared insightful experiences and perspectives. He talked about the importance of IIChE and encouraged students to appreciate this field, providing us with an industry roadmap. This was followed by Dr. T. Kannadasan, who expounded on current trends and challenges in chemical engineering.This memorable event will pave the way for more events, efforts, and inspiration from the members, which will be used for the benefit of our field and students.",
  },
  {
    id: 10,
    EventTitle: "WORKSHOP ON SOLAR PHOTOVOLTAIC APPLICATIONS",
    Date: "20th to 22nd September 2023",
    EventDescription:
      "This workshop on Solar Photovoltaics Applications marks our inaugural event since the chapter's inception. The solar photovoltaics workshop was spanned over three days, and we were privileged to have had our esteemed guest speakers: Dr. Kalyanasundaram, Dr. Krishnamoorthy, Professor Uchida, Dr. Sudip Kumar and Dr. Duraisamy Kumaresan. On the first day Dr. Kalyanasundaram provided comprehensive insights into the fabrication of solar cells, spanning from the initial silicon feedstock to the eventual photovoltaic system. We had the privilege of an online talk by Dr. Krishnamoorthy, who conducted an in-depth discussion on the fundamental principles and recent advancements in applications of organic photovoltaics.On the second day we had presentation by Professor Uchida whose presentation encompassed both the foundational sciences and practical breakthroughs in Dye-Sensitized and perovskite solar cells. Then Dr. Sudip Kumar delved into the operation of solar cells, with a specific emphasis on CIGS solar cells. Dr. Kumaresan elucidated the electrochemical impedance analysis (EIS) of DSSCs utilizing bi-layer photoanodes.On the last day, a Do It Yourself (DIY) session on various methods of harnessing solar energy was conducted.",
  },
  {
    id: 11,
    EventTitle:
      "WORKSHOP ON DESIGN OF DISTILLATION COLUMN USING MICROSOFT EXCEL",
    Date: "27th and 28th October 2023",
    EventDescription:
      "The workshop on Design of distillation column using Excel, conducted by Dr. Udhay Bhaskar Reddy Ragula deserves our heartfelt appreciation. The workshop provided hands-on experience on estimation of equilibrium data from fundamental thermodynamic data (vapor pressure and relative volatility calculations), estimation of feed quality (such as subcooled liquid, saturated liquid, saturated vapor, liquid at its boiling point and superheated vapor) from the feed temperature, feed pressure and feed mole fraction, calculation of minimum and operating reflux ratio for rectification and stripping section of the distillation column and the total number of trays that are required for distillation column for the required separation, which were all performed using Microsoft excel.",
  },

  {
    id: 12,
    EventTitle: "KICK-OFF'23",
    Date: "31.10.2023 to 8.11.2023",
    EventDescription:
      "Kick-Off'23 marked a triumphant success for the IIChE Students Chapter, captivating the campus for a period of 9 days. This spirited event featured a thrilling 7’s football tournament with an impressive turnout of 27 registered teams. The competitive fervour unfolded through strategically organized matches, commencing with knockout rounds, progressing to quarter-finals, gripping semi-finals, and culminating in an electrifying grand finale. This event went beyond the realm of sports, as it became a milestone for the IIChE AVVU Students Chapter, serving as their inaugural fundraiser. The generated funds promise to fuel the organization's upcoming initiatives, fostering a dynamic and vibrant student community. Nemesis FC emerged as the deserving champions in the nail-biting final clash against Knightfall FC, seizing both a substantial cash prize and a magnificent trophy. The campus resonated with the cheers and applause, attesting to the impactful nature of the event. This event, with its blend of sportsmanship, camaraderie, and fundraising success, stands as a testament to the chapter's ability to create memorable and impactful experiences for the entire campus community",
  },
  {
    id: 13,
    EventTitle: "SPOT PHOTOGRAPHY",
    Date: "29.04.2024",
    EventDescription:
      "Unleash your artistic vision and delve into the art of capturing moments that transcend time. In this competition, participants will have the opportunity to encapsulate the essence of the moment through their lens. Every snapshot is a canvas waiting to narrate a tale, evoke sentiments, and leave a lasting imprint.Are you prepared to let your creativity soar and leave your mark on the world of photography? Join us in this exciting endeavor and let your snapshots speak volumes.",
  },
  {
    id: 14,
    EventTitle: "Kick-Off '24",
    Date: "05.08.24 to 13.08.24",
    EventDescription:
      "Kick-Off '24, organized by IIChE AVVU Students Chapter, was a thrilling 9-day 7's football tournament with 24 registered teams. The event progressed through knockouts, quarterfinals, and a nail-biting finale where Nemesis FC triumphed over Minnal FC, earning the championship trophy and a cash prize. Beyond sports, it served as a successful fundraiser, fostering campus unity and showcasing athletic talent. The tournament solidified its role as a flagship event for community-building and fundraising.",
  },
  {
    id: 15,
    EventTitle: "ChemE Silver Series-1",
    Date: "08.08.24",
    EventDescription:
      "The inaugural ChemE Silver Series seminar by IIChE-AVVU featured Dr. Ramakrishnan Shanmugam from Newcastle University, UK, who discussed green hydrogen production, electrolyzer challenges, and sustainable technologies. The session provided insights into renewable energy, electrolyzer applications, and their advantages and limitations. Faculty support and active participation from students, including a productive Q&A session, made the event a success, broadening perspectives on sustainable energy research.",
  },
  {
    id: 16,
    EventTitle:
      "ADVANCEMENTS AND APPLICATIONS OF ICP-OES TECHNOLOGY BY AGILENT TECHNOLOGIES",
    Date: "12.09.24",
    EventDescription:
      "On 12th September 2024, Agilent Technologies conducted a session to explain the features of their newly installed ICP-OES() technology at Centre of Excellence in Advanced Materials and Green Technologies (CoE-AMGT), Amrita Vishwa Vidyapeetham, Coimbatore. It was an enlightening session, which briefed the students and faculties about various features of the equipment, provided information about other types of equipment produced by their company, and concluded with a hands-on training/live demonstration of the newly installed equipment. ",
  },
  {
    id: 17,
    EventTitle: "Technical Dungeon",
    Date: "17.10.24",
    EventDescription:
      "Anokha 2024, the national techfest of Amrita Vishwa Vidyapeetham, Coimbatore campus, concluded its 12th edition on October 19, 2024. The event, held from October 17-19, provided a platform for students across India to engage in technical activities and enhance their skills. The Department of Chemical Engineering & Material Science along with IIChE Student Chapter conducted events – Technical Dungeon, Path Quest, Workshop, and also students represented our department in the Tech-Fair & Exhibitions, they exhibited projects done by them as well as our professors. Technical Dungeon, held on 17th October, 2024, where 21 teams faced ultimate tests of knowledge, strategy, and teamwork! This fast-paced competition challenged participants through dynamic games that pushed their scientific know-how and quick thinking to the limit. From timed tasks to luck-driven challenges, each round demanded collaboration and problem-solving from each team.",
  },
  {
    id: 18,
    EventTitle: "'Chemical Engineering in Semiconductors",
    Date: "19.10.24",
    EventDescription:
      "Anokha 2024, the national techfest of Amrita Vishwa Vidyapeetham, Coimbatore campus, concluded its 12th edition on October 19, 2024. The event, held from October 17-19, provided a platform for students across India to engage in technical activities and enhance their skills. The Department of Chemical Engineering & Material Science along with IIChE Student Chapter conducted events – Technical Dungeon, Path Quest, Workshop, and also students represented our department in the Tech-Fair & Exhibitions, they exhibited projects done by them as well as our professors. An engaging workshop on 'Chemical Engineering in Semiconductors' was organized on 19th October, 2024. Ms. Sornavalli Ramanathan (Intel Technologies) shared valuable insights into the critical role of Chemical Engineers in modern semiconductor manufacturing. Attendees learned about cutting-edge techniques, explored career paths, and even participated in a fun activity with exciting prizes!. The workshop covered a wide range of topics, including semiconductor device fabrication, materials science, and process engineering. Participants gained a strong understanding of the fundamental principles of semiconductor manufacturing and the critical role that Chemical Engineers play in this rapidly evolving field.",
  },
  {
    id: 19,
    EventTitle: "Path Quest ",
    Date: "18.10.24",
    EventDescription:
      "Anokha 2024, the national techfest of Amrita Vishwa Vidyapeetham, Coimbatore campus, concluded its 12th edition on October 19, 2024. The event, held from October 17-19, provided a platform for students across India to engage in technical activities and enhance their skills. The Department of Chemical Engineering & Material Science along with IIChE Student Chapter conducted events – Technical Dungeon, Path Quest, Workshop, and also students represented our department in the Tech-Fair & Exhibitions, they exhibited projects done by them as well as our professors. Path Quest was an exhilarating competition, held on 18th October, 2024 that challenged 15 teams to showcase their problem-solving skills, creativity, and teamwork! With two thrilling rounds - Flow Craft and Triumph Trail - teams had to craft solutions to real-world problems. From creating comprehensive process flow diagrams to devising innovative solutions, every step was a test of their ingenuity. Top 5 teams presented their sustainable solutions for challenging questions to a panel of faculty judges, while others bid on proposed solutions for a chance to win.",
  },
  {
    id: 20,
    EventTitle: "Anokha 2024 Techfair & Exhibition ",
    Date: "17.10.24 to 19.10.24",
    EventDescription:
      "Anokha 2024 featured a Techfair & Exhibition showcasing over 50 projects aligned with the UN Sustainable Development Goals (SDGs). Notable projects from our department included Lemongrass distillation column, Microchannel based cogeneration unit for efficient utilization of solar energy, Oxygen concentrator, these projects of Dr. Udaya Bhaskar, Water electrolyzer project of Dr. Murali Rangarajan, Imidizole-pyridine molecule for multitarget cancer cell project of Dr.Bala Dhandabhani, Flexible solar cell project of Dr. Duraiswamy Kumaresan, Amritha Seed Grant Project of Dr. Meera Balachandran, models of these projects were very well presented by our B.Tech and M.Tech students.  ",
  },
  {
    id: 21,
    EventTitle: "IIChE Campaign",
    Date: "19.10.24",
    EventDescription:
      "The Publicity committee hosted a campaign during Anokha 2024, they engaged with a wide range of people, interacted with them, asked questions, riddles and encouraged them to follow our IIChE social media pages. Our team connected with around 60 individuals across campus, as well as attendees from other institutions. The campaign team included Arjun, Publicity Head, Abhiram V Menon, Editorial Head, Vasinthya Tej, Technical Head and fourth year volunteers, Greeshma and Athulkrishna, their collective efforts were fruitful in attracting many students into connecting IIChE AVVU Student Chapter.",
  },
  {
    id: 22,
    EventTitle: "INDUCTION & FAREWELL EVENT",
    Date: "10.12.24",
    EventDescription:
      "On 10th December, 2024, The IIChE Student Chapter hosted its Induction and Felicitation Ceremony, celebrating the achievements of outgoing coheads, welcoming new leaders, and acknowledging the invaluable contributions of faculty and retiring heads. The event highlighted the chapter's ongoing journey of collaboration and innovation, setting the stage for a vibrant future.",
  },
  {
    id: 23,
    EventTitle: "L&T SESSION",
    Date: "13.12.24 to 14.12.24",
    EventDescription:
      "Two insightful tutorial sessions on Industrial Piping Engineering were conducted by Dr. Nakka Muralidhara Rao from Larsen & Turbo Edutech for our 3rd-year Chemical Engineering students on 13th and 14th December, 2024 .The sessions equipped students with the fundamental knowledge and practical skills necessary for designing and analyzing industrial piping systems. It helped them gain a strong understanding of industry standards, safety considerations, and the latest advancements in piping technology.",
  },
];

export const EC_2023 = [
  {
    Name1: "K P Jeevan",
    image1: "../images/Jeevan.jpg",
    Post1: "Secretary",
    Name2: "Aswathy",
    image2: "../images/Ashwathy.jpg",
    Post2: "Joint Secretary",
    Name3: "Sugesan V",
    image3: "../images/Sugesan.jpg",
    Post3: "Treasurer",
    Name4: "Niveditha Dinesh",
    image4: "../images/Niveditha.jpg",
    Post4: "PROGRAM",
    Name5: "Rohit Menon",
    image5: "../images/Rohith.jpeg",
    Post5: "TECHNICAL",
    Name6: "K P Jeevan",
    image6: "../images/Jeevan.jpg",
    Post6: "EDITORIAL",
    Name7: "Suryansi Sahoo",
    image7: "../images/Suryanshi.jpeg",
    Post7: "Editorial",
    Name8: "Aakash",
    image8: "../images/Aakash.jpg",
    Post8: "GRAPHICS AND DESIGN",
    Name9: "Ankan",
    image9: "../images/Ankhan.jpg",
    Post9: "PUBLICITY",
    Name10: "Vishnu M",
    image10: "../images/Vishnu.jpg",
    Post10: "PUBLIC RELATIONS",
    Name11: "Gayathri S",
    image11: "../images/Gayatri.jpg",
    Post11: "Alumni and Industry Connect",
    Name12: "Karthikeyan M",
    image12: "../images/Karthikeyan.jpg",
    Post12: "SOCIAL  ENVIRONMENTAL and HR",
    Name13: "Swetha",
    image13: "../images/Swetha.jpg",
    Post13: "PROGRAM",
    Name14: "Sanithi Sunil",
    image14: "../images/Sanithi.jpeg",
    Post14: "PROGRAM",
    Name15: "Aswathy",
    image15: "../images/Ashwathy.jpg",
    Post15: "TECHNICAL",
    Name16: "Vasinthiya Tej A",
    image16: "../images/Vasinthyaa.jpg",
    Post16: "TECHNICAL",
    Name17: "Divya K",
    image17: "../images/Divya.jpg",
    Post17: "Editorial",
    Name18: "Abhiram V",
    image18: "../images/Abhiram.jpg",
    Post18: "Editorial",
    Name19: "Rishi Nandan",
    image19: "../images/Rishi.jpg",
    Post19: "GRAPHICS AND DESIGN",
    Name20: "Siva Pratap P",
    image20: "../images/Siva.JPG",
    Post20: "GRAPHICS AND DESIGN",
    Name21: "Abigna",
    image21: "../images/Abigna.jpg",
    Post21: "Publicity",
    Name22: "Arjun Raj",
    image22: "../images/Arjun.jpg",
    Post22: "Publicity",
    Name23: "Sugesan V",
    image23: "../images/Sugesan.jpg",
    Post23: "Public Relations",
    Name24: "Roshan Reddy",
    image24: "../images/Roshan.jpg",
    Post24: "Public Relations",
    Name26: "Deepanshi Paul",
    image26: "../images/Deepanshi.jpg",
    Post26: "Alumni and Industry Connect",
    Name25: "Prathibha Prasad",
    image25: "../images/Prathibha.jpg",
    Post25: "Social Environmnetal and HR",
  },
];

export const EC_2024 = [
  {
    Name1: "K P Jeevan",
    image1: "../images/Jeevan.jpg",
    Post1: "Secretary",
    Name2: "Divya K",
    image2: "../images/Divya.jpg",
    Post2: "Joint Secretary",
    Name3: "Sugesan V",
    image3: "../images/Sugesan.jpg",
    Post3: "Treasurer",
    Name4: "Aakash",
    image4: "../images/Aakash.jpg",
    Post4: "Secretary Associate",
    Name5: "Abhiram V",
    image5: "../images/Abhiram.jpg",
    Post5: "Joint Secretary Associate",
    Name6: "Rishi Nandan",
    image6: "../images/Rishi.jpg",
    Post6: "TREASURER Associate",
    Name7: "Deepanshi Paul",
    image7: "../images/Deepanshi.jpg",
    Post7: "Alumni and Industry Connect",
    Name8: "Rohan M",
    image8: "../images/Rohan.jpg",
    Post8: "Alumni and Industry Connect",
    Name9: "Divya K",
    image9: "../images/Divya.jpg",
    Post9: "Editorial",
    Name10: "Abhiram V",
    image10: "../images/Abhiram.jpg",
    Post10: "Editorial",
    Name11: "Rishi Nandan",
    image11: "../images/Rishi.jpg",
    Post11: "GRAPHICS AND DESIGN",
    Name12: "Siva Pratap P",
    image12: "../images/Siva.JPG",
    Post12: "GRAPHICS AND DESIGN",
    Name13: "Swetha",
    image13: "../images/Swetha.jpg",
    Post13: "PROGRAM",
    Name14: "Nandagovind",
    image14: "../images/Nanda.jpg",
    Post14: "PROGRAM",
    Name15: "Abigna",
    image15: "../images/Abigna.jpg",
    Post15: "Publicity",
    Name16: "Arjun Raj",
    image16: "../images/Arjun.jpg",
    Post16: "Publicity",
    Name17: "Sugesan V",
    image17: "../images/Sugesan.jpg",
    Post17: "Public Relations",
    Name18: "Roshan Reddy",
    image18: "../images/Roshan.jpg",
    Post18: "Public Relations",
    Name19: "Prathibha Prasad",
    image19: "../images/Prathibha.jpg",
    Post19: "SOCIAL  ENVIRONMENTAL and HR",
    Name20: "Vasinthiya Tej A",
    image20: "../images/Vasinthyaa.jpg",
    Post20: "TECHNICAL",
    Name21: "Niranjana Anur Aruna",
    image21: "../images/Niranjan.jpg",
    Post21: "PROGRAM",
    Name22: "Ambati Poojitha",
    image22: "../images/Poojitha.jpg",
    Post22: "PROGRAM",
    Name23: "Deepthisri KR",
    image23: "../images/photo.png",
    Post23: "Technical ",
    Name24: "Dhivyan PB",
    image24: "../images/Dhivyan.jpg",
    Post24: "Technical",
    Name25: "Harini C",
    image25: "../images/Harni.jpg",
    Post25: "Editorial",
    Name26: "Swarnakamatchi",
    image26: "../images/Swarnakamatchi .jpg",
    Post26: "Editorial",
    Name27: "Paruchuri Ananyasai",
    image27: "../images/photo.png",
    Post27: "Graphics and Design",
    Name28: "Abhijith Babu",
    image28: "../images/Abijith.JPG",
    Post28: "Graphics and Design",
    Name29: "Arathi Sreekumar",
    image29: "../images/Arathi.jpg",
    Post29: "Publicity",
    Name30: "Deetchana Manivel",
    image30: "../images/Deetcha.jpg",
    Post30: "Publicity",
    Name31: "Abaya Pradahan",
    image31: "../images/Abaya.jpg",
    Post31: "Public Relations",
    Name32: "Nishtha Sinha",
    image32: "../images/Nistha.jpg",
    Post32: "Public Relations",
    Name33: "Aadithya R Nair",
    image33: "../images/Aadithya.jpg",
    Post33: "Social Environmental and HR",
    Name34: "Adithya Dev A",
    image34: "../images/AdityaDev.jpg",
    Post34: "Social Environmental and HR",
    Name35: "Anukrithika.R",
    image35: "../images/Anukruthika.jpg",
    Post35: "Alumni and Industry Connect",
    Name36: "Rahul Kishor",
    Post36: "Alumni and Industry Connect",
    image36: "../images/Rahul.jpg",
    Name37: "Aakash",
    image37: "../images/Aakash.jpg",
    Post37: "GRAPHICS AND DESIGN",
  },
];

export const EC_2025 = [
  {
    Name1: "Sugesan V",
    image1: "../images/Sugesan.jpg",
    Post1: "Secretary",
    Name2: "Paruchuri Ananyasai",
    image2: "../images/photo.png",
    Post2: "Joint Secretary",
    Name3: " Deetchana Manivel",
    image3: "../images/Deetcha.jpg",
    Post3: "Treasurer",
    Name4: "Siva Pratap P",
    image4: "../images/Siva.JPG",
    Post4: "Secretary Associate",
    Name5: "Swarnakamatchi R",
    image5: "../images/Swarnakamatchi .jpg",
    Post5: "Joint  Secretary  Associate",
    Name6: "Abhijith Babu",
    image6: " ../images/Abijith.JPG",
    Post6: "TREASURER Associate",
    Name7: "Ambati Poojitha",
    image7: "../images/Poojitha.jpg",
    Post7: "PROGRAM",
    Name8: "Niranjana Anur Aruna",
    image8: "../images/Niranjan.jpg",
    Post8: "PROGRAM",
    image9: "../images/Dhivyan.jpg",
    Name9: "Dhivyan PB",
    Post9: "Technical",
    image10: "../images/photo.png",
    Name10: "Deepthisri KR",
    Post10: "Technical",
    Name11: "Harini C",
    image11: "../images/Harni.jpg",
    Post11: "Editorial",
    Name12: "Swarnakamatchi R",
    image12: "../images/Swarnakamatchi .jpg",
    Post12: "Editorial",
    Name13: "Abhijith Babu",
    image13: "../images/Abijith.JPG",
    Post13: "Graphics and Design",
    Name14: "Paruchuri Ananyasai",
    image14: "../images/photo.png",
    Post14: "Graphics and Design",
    Name15: "Arathi Sreekumar",
    image15: "../images/Arathi.jpg",
    Post15: "Publicity",
    Name16: "Deetchana Manivel",
    image16: "../images/Deetcha.jpg",
    Post16: "Publicity",
    Name17: "Abaya Pradahan",
    image17: "../images/Abaya.jpg",
    Post17: "Public Relations",
    Name18: "Nishtha Sinha",
    image18: "../images/Nistha.jpg",
    Post18: "Public Relations",
    Name19: "Aadithya R Nair",
    image19: "../images/Aadithya.jpg",
    Post19: "SOCIAL  ENVIRONMENTAL and HR",
    Name20: "Adithya Dev A",
    image20: "../images/AdityaDev.jpg",
    Post20: "SOCIAL  ENVIRONMENTAL and HR",
    Name21: "Anukrithika R",
    image21: "../images/Anukruthika.jpg",
    Post21: "Alumni and Industry Connect ",
    Name22: "Rahul Kishor",
    Post22: "Alumni and Industry Connect",
    image22: "../images/Rahul.jpg",
    Name23: "R Haritha",
    image23: "../images/Haritha.jpg",
    Post23: "Program",
    Name24: "C Tracy Cordelia",
    image24: "../images/Tracy_Cordelia.jpg",
    Post24: "Program",
    Name25: "Mahima Shivagurunathan",
    image25: "../images/Mahima.jpg",
    Post25: "Technical",
    Name26: "Dharshan B",
    image26: "../images/Dharshan.jpg",
    Post26: "Technical",
    Name27: "Aparna Shankar",
    image27: "../images/Aparna .jpg",
    Post27: "Editorial ",
    Name28: "Rithan K A",
    image28: "../images/Rithan.jpg",
    Post28: "Editorial",
    Name29: "S Krishnaendu Nair",
    image29: "../images/Krishnaendu.jpg",
    Post29: "Graphics and Design",
    Name30: "Visram Anand R V",
    image30: "../images/Visram.jpg",
    Post30: "Graphics and Design",
    Name31: "Anjali A S",
    image31: "../images/Anjali.jpg",
    Post31: "Publicity",
    Name32: "Bhavithira M",
    image32: "../images/Bhavithira.jpg",
    Post32: "Publicity",
    Name33: "M Nishiga",
    image33: "../images/Nishiga.jpg",
    Post33: "Public Relations",
    Name34: "Poobithasri V S",
    image34: "../images/Poobithasri.jpg",
    Post34: "Public Relations",
    Name35: "M Namrithasre",
    image35: "../images/Namrithasre.jpg",
    Post35: "SOCIAL ENVIRONMENTAL AND HR",
    Name36: " Santhosh A",
    image36: "../images/Santhosh.jpg",
    Post36: "SOCIAL ENVIRONMENTAL AND HR ",
    Name37: "K Gobika",
    image37: "../images/Gobika.jpg",
    Post37: "Alumni and Industry Connect",
    Name38: "PG Krdvi Sree",
    image38: "../images/Krdvi.jpg",
    Post38: "Alumni and Industry Connect",
  },
];
